import {set} from "lodash";
import {SocialNetwork} from "data/enums";
import {SHARE_URL} from "data/constants";

interface IGeneralShare {
	socialNetwork: SocialNetwork;
	userId: number;
	roundId: number;
	message?: string;
}

type IShare = IGeneralShare;

const getTimestamp = () => Date.now().toString().substring(9);

const getEncodedJson = (object: Partial<IShare> & {t: string}) =>
	window.btoa(JSON.stringify(object));

export const getLinkForShare = (data: IShare) => {
	const params = {t: getTimestamp()};

	set(params, "userId", data.userId);
	set(params, "roundId", data.roundId);

	return `${SHARE_URL}${getEncodedJson(params)}`;
};

const shareFB = (data: IShare) => {
	if (!window.fbShare) {
		throw new Error("No Facebook share provider found");
	}
	const link = getLinkForShare(data);

	window.fbShare(link);
};

const shareTW = ({message = "", ...params}: IShare) =>
	window.open(
		"https://twitter.com/share?url=" +
			encodeURIComponent(getLinkForShare(params)) +
			"&text=" +
			encodeURIComponent(message),
		"twitter-share_modal-dialog",
		"width=626,height=436"
	);

const shareMobile = ({message = "", ...params}: IShare) => {
	try {
		void navigator.share({
			url: getLinkForShare(params),
			text: message,
		});
	} catch (err) {
		console.log(err);
	}
};

const callbacks = {
	[SocialNetwork.Twitter]: shareTW,
	[SocialNetwork.Facebook]: shareFB,
	[SocialNetwork.Mobile]: shareMobile,
} as const;

export const share = (data: IShare) => callbacks[data.socialNetwork](data);
